/* Echo Valley landing page behaviour.
   Loaded with defer from the layout so it runs AFTER every section is parsed --
   an inline script in the first section only ever saw its own markup, which left
   later sections stuck at opacity:0.

   The persistent buy bar lives in ev-sticky-bar.js, not here: it is the one
   behaviour that must survive frame throttling, so it deliberately avoids the
   IntersectionObserver everything below depends on. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  // ---- gradient last word ---------------------------------------------
  /* Every section headline's LAST word takes the hero's brand gradient
     (styled by .ev-gword in ev-polish.css). Done here so the headline
     settings stay plain text an editor can change freely; the wrap re-derives
     from whatever the text is. textContent in, one span out, no user HTML
     ever parsed. Runs before the reveal observer so the cascade lifts the
     finished headline, not one that restyles mid-flight. */
  document.querySelectorAll('h2.ev-big').forEach(function(h){
    if (h.querySelector('.ev-gword')) return;
    var words = h.textContent.trim().split(/\s+/);
    if (words.length < 2) return;
    var last = words.pop();
    h.textContent = words.join(' ') + ' ';
    var s = document.createElement('span');
    s.className = 'ev-gword';
    s.textContent = last;
    h.appendChild(s);
  });

  // ---- scroll reveals -------------------------------------------------
  var reveals = document.querySelectorAll('.ev-reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    reveals.forEach(function(el){ el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    reveals.forEach(function(el){ io.observe(el); });
    requestAnimationFrame(function(){
      reveals.forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    });
  }

  // ---- ambient flux field behind the hero -----------------------------
  var c = document.querySelector('.ev-flux');
  if (c && !reduce) {
    var x = c.getContext('2d'), w = 0, h = 0,
        dpr = Math.min(window.devicePixelRatio || 1, 2),
        t = 0, run = false, raf = 0, visible = false;
    function size(){ w = c.clientWidth; h = c.clientHeight; c.width = w*dpr; c.height = h*dpr; x.setTransform(dpr,0,0,dpr,0,0); }
    size();
    if (window.ResizeObserver) new ResizeObserver(size).observe(c);
    else window.addEventListener('resize', size, { passive:true });
    function frame(){
      if (!run) { raf = 0; return; }
      t += 0.0032; x.clearRect(0,0,w,h);
      for (var k=0;k<7;k++){
        var y0 = h*(0.12+k*0.13), amp = 16+k*4;
        x.beginPath();
        for (var i=0;i<=90;i++){
          var u=i/90, px=u*w,
              py=y0+Math.sin(u*5.4+t*1.3+k*1.7)*amp+Math.sin(u*2.1-t*0.8+k)*amp*0.45;
          i ? x.lineTo(px,py) : x.moveTo(px,py);
        }
        x.strokeStyle = 'rgba(240,114,210,'+(0.05+0.03*Math.sin(t+k))+')';
        x.lineWidth = 1; x.stroke();
      }
      raf = requestAnimationFrame(frame);
    }
    function setRun(v){ run = !!v; if (run && !raf) raf = requestAnimationFrame(frame); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){ visible = es[0].isIntersecting; setRun(visible && !document.hidden); }, { threshold:0 }).observe(c);
    } else { visible = true; setRun(true); }
    document.addEventListener('visibilitychange', function(){ setRun(visible && !document.hidden); });
  }

  // ---- engine videos --------------------------------------------------
  /* WARMING, AND WHY IT EXISTS.
     Only the visible tab's clip ever plays, and the markup ships preload="none"
     so opening the page does not pull six 1080p files. The cost of that was a
     stutter: clicking a tab requested the clip from a cold start, so the poster
     sat frozen for about a second before the first frame arrived. Texture never
     showed it because Texture is the tab that is already open on load.

     Two warm-ups remove the stall without spending the bandwidth up front:
       viewer scrolled into view -> every clip to preload="metadata"
       tab hovered or focused    -> that clip to preload="auto"
     Touch has no hover, so touchstart fires the same warm-up.

     NEVER call load() on a clip that is playing: it rewinds it to zero. Hence
     the paused/readyState guard, and hence warm() only ever escalates. */
  var PRE_RANK = { none: 0, metadata: 1, auto: 2 };

  function warm(v, level){
    if (!v || reduce) return;
    if (!v.paused || v.readyState >= 3) return;
    if ((PRE_RANK[v.preload] || 0) >= PRE_RANK[level]) return;
    v.preload = level;
    v.load();
  }
  function warmAll(level){
    document.querySelectorAll('.ev-panel video').forEach(function(v){ warm(v, level); });
  }

  function syncVideos(){
    document.querySelectorAll('.ev-panel').forEach(function(p){
      var v = p.querySelector('video');
      if (!v) return;
      var live = !p.hidden && !document.hidden && !reduce;
      if (live) {
        v.preload = 'auto';
        var pr = v.play(); if (pr && pr.catch) pr.catch(function(){});
      } else { v.pause(); }
    });
  }
  document.addEventListener('visibilitychange', syncVideos);

  // ---- the presets bento: playback ------------------------------------
  /* The library cell's clip. Not inside .ev-panel, carries no autoplay
     attribute, nothing else ever calls play() on it, so without this it
     freezes on frame one. KEYED ON .ev-pbento (with .ev-pduo kept for any
     cached HTML): an early version selected .ev-cyc and found the HERO'S
     cycler, silently doing nothing here. Prefix per section. */
  var pbv = [].slice.call(document.querySelectorAll('.ev-pbento video, .ev-pduo video'));
  if (pbv.length && !reduce && 'IntersectionObserver' in window) {
    pbv.forEach(function(v, i){
      var t = 0;
      new IntersectionObserver(function(es){
        clearTimeout(t);
        if (es[0].isIntersecting) {
          if (v.preload !== 'auto') v.preload = 'auto';
          t = setTimeout(function(){
            var p = v.play(); if (p && p.catch) p.catch(function(){});
          }, i * 250);
        } else {
          v.pause();
        }
      }, { threshold: 0.15, rootMargin: '350px 0px' }).observe(v);
    });
    document.addEventListener('visibilitychange', function(){
      if (document.hidden) pbv.forEach(function(v){ v.pause(); });
    });
  }

  // ---- the live preset drawer -----------------------------------------
  /* The Diffusion PRESET LIBRARY rebuilt as DOM. Selection is the whole game:
     click a row and it highlights, arrows step through whatever the current
     category shows, stars fill and feed the FAVORITE view, categories filter
     with the plug-in's real mapping. Nothing loads anything.

     The counter stays ABSOLUTE (slot/20) even while a filter narrows the list,
     because that is exactly what the plug-in's preset bar does: it counts the
     bank, not the view. USER is genuinely empty, like a fresh install, and the
     empty states say so instead of showing a blank pane. */
  (function(){
    var lib = document.querySelector('.ev-plib');
    if (!lib) return;
    var rows  = [].slice.call(lib.querySelectorAll('.ev-plib-row'));
    var cats  = [].slice.call(lib.querySelectorAll('.ev-plib-cat'));
    var arrs  = [].slice.call(lib.querySelectorAll('.ev-plib-arr'));
    var list  = lib.querySelector('.ev-plib-list');
    var empty = lib.querySelector('.ev-plib-empty');
    var nameEl = lib.querySelector('.ev-plib-name');
    var curEl  = lib.querySelector('.ev-plib-cur');
    var cntEl  = lib.querySelector('.ev-plib-count');
    if (!rows.length) return;
    var names = rows.map(function(r){ return r.querySelector('span').textContent; });
    var sel = 0, cat = 'All', fav = {};

    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function showing(i){
      if (cat === 'All') return true;
      if (cat === 'User') return false;
      if (cat === 'Favorite') return !!fav[i];
      return rows[i].getAttribute('data-cat') === cat;
    }
    function render(){
      var any = false;
      rows.forEach(function(r, i){
        var on = showing(i);
        r.hidden = !on; if (on) any = true;
        r.classList.toggle('is-sel', i === sel);
        var st = r.querySelector('.ev-plib-star');
        st.textContent = fav[i] ? '★' : '☆';
        st.classList.toggle('is-fav', !!fav[i]);
      });
      cats.forEach(function(b){ b.classList.toggle('is-on', b.getAttribute('data-cat') === cat); });
      nameEl.textContent = names[sel];
      curEl.textContent  = names[sel];
      cntEl.textContent  = pad(sel + 1) + '/' + rows.length;
      if (!any) {
        empty.hidden = false;
        empty.textContent = cat === 'User'
          ? 'Nothing saved yet. SAVE writes your own presets into this bank.'
          : 'Star a preset and it lives here.';
      } else { empty.hidden = true; }
    }
    function step(d){
      var vis = [];
      rows.forEach(function(r, i){ if (showing(i)) vis.push(i); });
      if (!vis.length) return;
      var at = vis.indexOf(sel);
      sel = at < 0 ? vis[0] : vis[(at + d + vis.length) % vis.length];
      render();
      var r = rows[sel];
      if (!r.hidden && r.scrollIntoView) r.scrollIntoView({ block: 'nearest' });
    }
    rows.forEach(function(r, i){
      r.addEventListener('click', function(e){
        if (e.target.closest('.ev-plib-star')) {
          fav[i] = !fav[i]; render(); return;
        }
        sel = i; render();
      });
    });
    cats.forEach(function(b){
      b.addEventListener('click', function(){
        cat = b.getAttribute('data-cat');
        if (list) list.scrollTop = 0;
        render();
      });
    });
    arrs.forEach(function(b){
      b.addEventListener('click', function(){ step(parseInt(b.getAttribute('data-d'), 10) || 1); });
    });
    render();
  })();

  // ---- engine viewer tabs ---------------------------------------------
  var tabs = [].slice.call(document.querySelectorAll('.ev-tab'));
  if (tabs.length) {
    var show = function(id){
      tabs.forEach(function(tb){
        var on = tb.id === 'ev-t-' + id;
        tb.setAttribute('aria-selected', on ? 'true' : 'false');
        var p = document.getElementById('ev-p-' + tb.id.replace('ev-t-',''));
        if (p) p.hidden = !on;
      });
      syncVideos();
    };
    tabs.forEach(function(tb, i){
      var eng = tb.id.replace('ev-t-','');
      var preheat = function(){
        var p = document.getElementById('ev-p-' + eng);
        if (p) warm(p.querySelector('video'), 'auto');
      };
      tb.addEventListener('pointerenter', preheat);
      tb.addEventListener('focus', preheat);
      tb.addEventListener('touchstart', preheat, { passive: true });

      tb.addEventListener('click', function(){ show(eng); });
      tb.addEventListener('keydown', function(e){
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus(); show(n.id.replace('ev-t-',''));
      });
    });
    // Warm on approach, pause everything while the viewer is scrolled away.
    var viewer = document.getElementById('ev-viewer');
    if (viewer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(es){
        if (es[0].isIntersecting) { warmAll('metadata'); syncVideos(); }
        else document.querySelectorAll('.ev-panel video').forEach(function(v){ v.pause(); });
      }, { threshold: 0.05, rootMargin: '400px 0px' }).observe(viewer);
    }
  }
})();
